import { createApp } from 'vue';
import { IonicVue } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import piniaPersist from 'pinia-plugin-persistedstate';

import App from './App.vue';
import router from './router';
import pinia from './store';
import { sqliteService } from './services/storage/sqlite.service';
import { setupAuthExpiredListener } from './store/auth.store';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

pinia.use(piniaPersist);

const app = createApp(App).use(IonicVue).use(pinia).use(router);

router.isReady().then(async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      await sqliteService.init();
    } catch (error) {
      console.warn('Offline cache could not be initialized.', error);
    }
  }

  // Set up auth expired event listener
  setupAuthExpiredListener();

  // Remove loading indicator
  const loading = document.getElementById('loading');
  if (loading) {
    loading.remove();
  }

  app.mount('#app');
});
